<template>
    <div class="md-form get-more-info-v6" :style="{ backgroundColor: bgColor }">
        <module-box
            class="form-container"
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
        >
            <div class="agent-box">
                <div v-if="title" class="title" v-html="formatFontSize(title, 30)" style="font-family:var(--mg-title-font)"></div>
                <p v-if="agent.email" class="info-item email">
                    <a
                        :href="'mailto:' + agent.email"
                        rel="noopener noreferrer"
                    >
                        <i class="iconfont icon-email-small"></i>
                        <span>{{ agent.email }}</span>
                    </a>
                </p>
                <p v-if="agent.email" class="info-item phone">
                    <a
                        :href="'tel:' + agent.phone"
                        target="_top"
                        rel="noopener noreferrer"
                    >
                        <i class="iconfont icon-call-small"></i>
                        <span>{{ $ft.formatPhone(agent.phone) }}</span>
                    </a>
                </p>
                <p v-if="agent.address" class="info-item address">
                    <i class="iconfont icon-address"></i>
                    <span>{{ agent.address }}</span>
                </p>
            </div>
            <div class="message-box">
                <div class="title" v-html="formatFontSize(messageTitle, 30)"></div>
                <v-form
                    ref="form"
                    class="form"
                    :onSubmit="onSubmit"
                    :onSuccess="onSuccess"
                    :onError="onError"
                >
                    <v-input
                        class="message"
                        name="question"
                        tag="textarea"
                        :placeholder="
                            messageOption.placeholder || $t('md-form.message')
                        "
                        :required="messageOption.required"
                    />
                    <div class="submit-box">
                        <button
                            class="submit"
                            v-html="submitOption || $t('md-form.submit')"
                            :disabled="submitDisabled"
                            :class="{ 'submit-disabled': submitDisabled }"
                            :style="{
                                backgroundColor: submitBgColor,
                            }"
                        ></button>
                    </div>
                </v-form>
            </div>
            <form-toast
                v-model:visible="formToastVisible"
                v-bind="formToastOption"
                @confirm="handleToastConfirm"
            />
        </module-box>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { useUserStore, usePageStore } from '@/store';

import common from '../index';
import vForm from '../../../components/v-form.vue';
import vInput from '../../../components/v-input.vue';
import signLog from '../../../components/sign-log';
import formToast from '@/components/form-toast';
import { normal } from '../../defaultSpacing';
export default {
    mixins: [common],
    data: function() {
        return {
            submitDisabled: false,
            ...normal
        };
    },
    computed: {
        ...rootMapState(usePageStore, {
            "page": store => store.page
        }),
        ...rootMapState(useUserStore, {
            "user": store => store.user
        }),
        messageTitle() {
            let messageTitle =
                this.messageOption.title || this.$t('md-form.leaveAMessage');
            if (this.messageOption.required) {
                if (messageTitle.indexOf('</p>') !== -1) {
                    messageTitle = messageTitle.replace(
                        '</p>',
                        '<span>*</span></p>'
                    );
                } else {
                    messageTitle = messageTitle + '*';
                }
            }
            return messageTitle;
        },
        messageOption() {
            let options = {};
            this.formList.forEach(item => {
                if (item.name === 'question') {
                    options = {
                        title: item.title,
                        placeholder:
                            item.placeholder ||
                            this.$t('md-form.whatWouldYouLikeTo'),
                        required: item.required
                    };
                }
            });
            return options
        }
    },
    methods: {
        leaveMessage(data, callback) {
            data.otherMsg = this.page.page || '';
            data.name = data.fullname || this.user.fullName || '';
            data.phoneNum = data.phone || this.user.phoneNumber || '';
            data.emailAddress = data.email || this.user.account || '';
            data.pageUrl = this.pageLocation.href;
            data.pageUri = this.pageLocation.href;
            // listingId and isSoldListing  rear end GlobalData Give
            if (this.page.listingId !== undefined) {
                data.listingId = this.page.listingId;
            }
            if (this.page.isSoldListing !== undefined) {
                data.sold = this.page.isSoldListing;
            }
            this.axiosIns
                .post('/api-site/leaveMsg', data)
                .then(() => {
                    callback && callback();
                })
                .catch(e => {
                    console.log(e);
                });

            this.$EventBus.$emit('siteTrack', {
                msg: data.question || '',
                trackType: 'leave-message'
            });
        },
        onSuccessCallback() {
            this.handleShowToast();
            if (this.$refs.form) {
                this.$refs.form.reset({
                    question: ''
                });
            }
        },
        onSubmit() {
            //TODO: @weizeng.shu  Subsequent burying function supplement
        },
        onSuccess(data = {}) {
            this.submitDisabled = true;
            setTimeout(() => {
                this.submitDisabled = false;
            }, 3000);
            this.tag && (data.tagIds = this.tag); //SITE-12720
            if (this.user) {
                this.leaveMessage(data, this.onSuccessCallback);
            } else {
                signLog.register({
                    role: this.registerRole,
                    languageTextFn: {
                        registerTitle: _ => this.$t('md-form.leaveAMessage'),
                        registerSubTitle: _ =>
                            this.$t('md-form.haveAllOfYourQuestions')
                    },
                    registerData: data,
                    onregister: (user, inquiry) => {
                        !inquiry && this.onSuccessCallback();
                        return false;
                    },
                    onsuccess: (data, inquiry) => {
                        inquiry && this.onSuccessCallback();
                        return false;
                    }
                });
            }
        },
        onError() {
            //TODO: @weizeng.shu  Subsequent burying function supplement
        }
    },
    components: {
        vForm,
        vInput,
        formToast
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-form.get-more-info-v6 {
    .form-container {
        position: relative;
        display: flex;
        &:not(.mg-container) {
            padding-left: 20px;
            padding-right: 20px;
        }
        .title {
            color: var(--mg-title-color);
            font-size: 24px;
            font-family: var(--font-bold);
            line-height: 1.2;
            margin-bottom: 34px;
            @include webkitBox(2);
            p {
                line-height: inherit;
                overflow: hidden;
            }
        }
        .agent-box {
            margin-right: 80px;
            color: var(--color-text);
            max-width: 400px;
            .info-item {
                font-size: 16px;
                margin-bottom: 20px;
                line-height: 22px;
                a {
                    display: flex;
                    align-items: center;
                    span {
                        margin-left: 10px;
                        @include ellipsis();
                    }
                    .iconfont{
                        color: #a8a8a8;
                    }
                }
                &.address {
                    display: flex;
                    margin-bottom: 0;
                    span {
                        margin-left: 10px;
                    }
                }
            }
        }
        .message-box {
            flex: 1;
            min-width: 260px;
            @include placeholderColor(#a0a0a0);
            .title{
                text-transform: uppercase;
            }
            .message {
                textarea {
                    width: 100%;
                    background-color: #fff;
                    border-radius: 2px;
                    border: 1px solid #dcdcdc;
                    box-shadow: none;
                    height: 120px;
                    padding: 13px 15px;
                    font-size: 14px;
                    &::placeholder {
                        font-size: 16px;
                        color: #ccc;
                    }
                }
            }
            .submit-box {
                margin-top: 20px;
                text-align: right;
            }
            .submit {
                @include color-button-hover();
                display: inline-block;
                height: 40px;
                min-width: 120px;
                max-width: 100%;
                padding: 0 20px;
                border-radius: 2px;
                text-align: center;
                vertical-align: middle;
                font-size: 18px;
                @include color-button();
            }
            input[disabled='disabled'].submit-disabled {
                @include input-disabled();
            }
        }
    }
    @include media-800 {
        .form-container {
            flex-direction: column;
            .agent-box {
                margin-right: 0;
                width: 100%;
                max-width: none;
            }
            .message-box {
                width: 100%;
                margin-top: 40px;
            }
        }
    }
    @include media-600 {
        .form-container {
            &:not(.mg-container) {
                padding-left: 20px;
                padding-right: 20px;
            }
            .title {
                font-size: 20px;
                margin-bottom: 20px;
            }
        }
    }
}
</style>
